import { Typography } from '@mui/material';
import { SxProps } from '@mui/system';
import React, { ReactNode } from 'react';

import { theme } from '~/theme';

type PropsType = {
  children: ReactNode;
  color?: string;
  gap?: boolean;
  sx?: SxProps;
};

export const ProposalConfigSelectorOptionDescriptionRow = (
  props: PropsType,
) => {
  const { children, gap, color, sx } = props;
  return (
    <Typography
      variant={'caption'}
      sx={{
        display: 'block',
        ...(!!gap ? { marginTop: theme.spacing(0.5) } : {}),
        ...sx,
      }}
      color={color ?? theme.palette.text.secondary}
    >
      {children}
    </Typography>
  );
};
